/**
 * Created by Rumyantsev Daniil on 31.01.2018.
 */

import { Pipe, PipeTransform } from '@angular/core';
/*
 * Возвращает разницу во времени в формате строки между текущим временем и передаваемым
 *
 * Usage:
 *   dateInMillis | stringDate
 * Example:
 *   {{ date | stringDate }}
 *   formats to: 7 ч.
 */
@Pipe({name: 'stringDate'})
export class StringDatePipe implements PipeTransform {

  transform(answerDateMillis: any): string {

    if(answerDateMillis == null) {
      return null;
    }

    let answDate = new Date(answerDateMillis);
    // console.log('String date pipe date', answDate);
    let now = new Date();
    // console.log("!!In StringDate Pipe!! Answer Date: ", answDate);
    // console.log("!!In StringDate Pipe!! Now Date: ", now.toLocaleString("ru"));

    const diff = now.getTime() - answDate.getTime();

    if(diff < 0 || isNaN(diff)) {
      return null;
    }

    const diffDays = diff / (1000 * 60 * 60 * 24);

    if(diffDays > 1) {
      return Math.ceil(diffDays) + " д.";
    }

    const diffHours = diffDays * 24;

    if(diffHours > 1) {
      return Math.ceil(diffHours) + " ч.";
    }

    const diffMinutes = diffHours * 60;

    return Math.ceil(diffMinutes) + " м.";
  }

}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/pipe/string-date.pipe.ts